import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import Header from "@/components/landing/Header";
import Footer from "@/components/landing/Footer";
import Seo from "@/components/Seo";
import { ARTICLES } from "@/data/articles";

export default function RatgeberList() {
  return (
    <>
      <Seo
        title="Ratgeber: Auswandern & Gründen in Florida"
        description="Leitfäden auf Deutsch: LLC in Florida gründen, E-2-Visum für Unternehmer und die Relocation-Checkliste für die ersten 30 Tage in Florida."
        keywords="Auswandern Florida Ratgeber, LLC gründen Florida, E-2 Visum Ratgeber, Relocation Checkliste Florida, Auswanderung USA Tipps"
      />
      <Header />
      <main>
        <section
          data-testid="ratgeber-list-section"
          className="bg-sand pb-24 pt-36 lg:pb-32 lg:pt-44"
        >
          <div className="mx-auto max-w-7xl px-6 lg:px-10">
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-xs uppercase tracking-[0.3em] text-clay"
              data-testid="ratgeber-eyebrow"
            >
              Ratgeber
            </motion.p>
            <motion.h1
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.1 }}
              className="mt-8 max-w-3xl font-serif text-5xl leading-tight tracking-tight text-ink sm:text-6xl"
              data-testid="ratgeber-title"
            >
              Auswandern & Gründen in Florida –{" "}
              <span className="italic text-clay">ehrlich erklärt</span>
            </motion.h1>
            <motion.p
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.2 }}
              className="mt-8 max-w-2xl text-base leading-relaxed text-ink-muted md:text-lg"
              data-testid="ratgeber-intro"
            >
              Leitfäden aus der Praxis für Deutsche und Schweizer: von der
              LLC-Gründung über das E-2-Visum bis zur Ankunft in Florida.
            </motion.p>

            <ul
              className="mt-16 border-t border-line"
              data-testid="ratgeber-list"
            >
              {ARTICLES.map((article, index) => (
                <motion.li
                  key={article.slug}
                  initial={{ opacity: 0, y: 28 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.25 + index * 0.1 }}
                  className="border-b border-line"
                  data-testid={`ratgeber-item-${article.slug}`}
                >
                  <Link
                    to={`/ratgeber/${article.slug}`}
                    data-testid={`ratgeber-link-${article.slug}`}
                    className="group flex items-start justify-between gap-8 py-12 transition-colors hover:bg-sand-deep"
                  >
                    <div>
                      <div className="flex items-center gap-4 text-xs uppercase tracking-[0.2em] text-ink-muted">
                        <span className="text-clay">{article.category}</span>
                        <span className="inline-flex items-center gap-1.5">
                          <Clock className="h-3.5 w-3.5" />
                          {article.readingTime}
                        </span>
                      </div>
                      <h2 className="mt-4 max-w-2xl font-serif text-2xl tracking-tight text-ink transition-colors group-hover:text-clay sm:text-4xl">
                        {article.title}
                      </h2>
                      <p className="mt-4 max-w-2xl text-sm leading-relaxed text-ink-muted md:text-base">
                        {article.description}
                      </p>
                    </div>
                    <ArrowRight className="mt-2 hidden h-6 w-6 shrink-0 text-clay transition-transform group-hover:translate-x-1 sm:block" />
                  </Link>
                </motion.li>
              ))}
            </ul>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
